export enum DietaryPreference {
  VEGETARIAN = 'Vegetarian',
  HALAL = 'Halal',
  NO_SPECIAL_REQUIREMENTS = 'No Special Requirements',
  N_A = 'Not Applicable', // For those not attending
}

export interface RSVP {
  id: string;
  name: string;
  attending: boolean;
  dietaryPreference: DietaryPreference;
  timestamp: number;
}